import type Immutable from 'immutable';
import { createAction } from '@reduxjs/toolkit';

import type { Notification } from 'js/src/client';
import { NOTIFICATION_ACTIONS } from 'js/src/data/notifications/notification-types';
import type { ImmutableMap } from 'js/src/libs/consts';

export const storeNotifications = createAction<{
    notifications_list: Immutable.List<ImmutableMap<Notification>>;
}>(NOTIFICATION_ACTIONS.STORE_NOTIFICATIONS);

export const setLoadingNotifications = createAction<{
    isLoading: boolean;
}>(NOTIFICATION_ACTIONS.SET_LOADING_NOTIFICATIONS);

export const setNotificationsIsEmpty = createAction<{
    isEmpty: boolean;
}>(NOTIFICATION_ACTIONS.SET_NOTIFICATIONS_EMPTY);

export const setNotificationsAsRead = createAction<{
    notification_ids: number[];
}>(NOTIFICATION_ACTIONS.SET_NOTIFICATIONS_AS_READ);

export const setHasUnreadNotifications = createAction<{
    hasUnread: boolean;
}>(NOTIFICATION_ACTIONS.SET_HAS_UNREAD_NOTIFICATIONS);

export const setNumBeamerUpdates = createAction<{
    numUpdates: number;
}>(NOTIFICATION_ACTIONS.SET_NUM_BEAMER_UPDATES);
